function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.718.75a.75.75 0 01.75-.75h15a.75.75 0 01.75.75c0 .807-.018 1.575-.05 2.304a4.5 4.5 0 11-1.7 8.835c-1.185 2.798-2.817 4.166-4.25 4.517v3.259l2.138.534c.29.072.565.202.805.382l2.757 2.069a.75.75 0 01-.45 1.35h-15a.75.75 0 01-.45-1.35l2.757-2.069c.24-.18.515-.31.806-.382l2.137-.534v-3.26c-1.432-.35-3.064-1.719-4.25-4.518a4.5 4.5 0 11-1.697-8.835A49.617 49.617 0 013.718.75zm.149 3.81a3 3 0 101.08 5.903c-.5-1.575-.882-3.52-1.08-5.903zm15.124 5.903a3 3 0 001.08-5.903c-.2 2.385-.582 4.327-1.08 5.903zM5.224 1.5c.01.776.04 1.509.084 2.204.195 3.041.686 5.319 1.305 7C7.91 14.22 9.694 15 10.468 15a.75.75 0 01.75.75v3.915a1.5 1.5 0 01-1.135 1.455l-2.14.534a.75.75 0 00-.268.128l-.957.718h10.5l-.957-.718a.75.75 0 00-.27-.128l-2.137-.534a1.5 1.5 0 01-1.136-1.455V15.75a.75.75 0 01.75-.75c.774 0 2.56-.78 3.855-4.296.62-1.68 1.11-3.96 1.305-7 .045-.695.074-1.429.084-2.204H5.224z",
  fill: "#fff"
});

function SvgAchievement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
}

export default SvgAchievement;